import { getStorage, ref, deleteObject } from "firebase/storage";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useEffect, useMemo, useState } from "react";
import { FirebaseError } from "firebase/app";
import firebaseErrors from "../../modules/firebaseErrors";
import Spinner from "react-bootstrap/Spinner";

const storage = getStorage();

export interface DeleteProps {
	documentPath: string;
	onDeleted: () => void;
}

export default function Delete(props: DeleteProps) {
	const [deleting, setDeleting] = useState(false);
	const [error, setError] = useState<string>();

	const [showDeleteDocument, setShowDeleteDocument] = useState(false);

	const documentRef = useMemo(
		() => (props.documentPath ? ref(storage, props.documentPath) : undefined),
		[props.documentPath],
	);

	useEffect(() => {
		if (!showDeleteDocument) return;
		setError(undefined);
	}, [showDeleteDocument]);

	return (
		<div onClick={(event) => event.stopPropagation()}>
			<Button
				className="rounded-pill"
				variant="outline-secondary"
				onClick={() => {
					setShowDeleteDocument(true);
				}}>
				<div className="ratio-1x1">
					<i className="bi bi-trash fs-3" />
				</div>
			</Button>
			<Modal
				show={showDeleteDocument}
				onHide={() => !deleting && setShowDeleteDocument(false)}
				backdrop="static"
				keyboard={false}>
				<Modal.Header closeButton>
					<Modal.Title>Dokument löschen</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="mb-2">
						Bist du wirklich sicher, dass du dieses Dokument <b>unwiderruflich</b> löschen möchtest?
					</div>

					{error && <div className="mb-2 text-danger">{error}</div>}
				</Modal.Body>
				<Modal.Footer>
					<Button
						disabled={!showDeleteDocument || deleting}
						variant="danger"
						onClick={() => {
							setShowDeleteDocument(false);
						}}>
						Abbrechen
					</Button>
					<Button
						variant="success"
						disabled={!showDeleteDocument || deleting}
						onClick={async () => {
							if (!documentRef) return;

							setDeleting(true);
							setError(undefined);

							try {
								await deleteObject(documentRef);

								setDeleting(false);
								setShowDeleteDocument(false);

								props.onDeleted();
							} catch (error) {
								if (error instanceof FirebaseError) {
									setDeleting(false);

									const message = firebaseErrors[error.code] ?? error.message;

									setError(message);
									return;
								}

								throw error;
							}
						}}>
						{deleting && <Spinner className="me-1" animation="border" size="sm" />}
						Löschen
					</Button>
				</Modal.Footer>
			</Modal>
		</div>
	);
}
